module.exports = __webpack_public_path__ + "static/media/proj_5.60209dd8.png";